<script>
  import InputWrapper from "./form/InputWrapper.svelte";
  //import CustomIcon from "./CustomIcon.svelte";
  import { countries, languages } from "../assets/GeoData";
  import AddList from "./form/AddList.svelte";
  import { getList } from "../api";
  // import InputTags from "./form/InputTags.svelte";
  import AutoCompleteCombo from "./form/AutoCompleteCombo.svelte";
  import Validators from "../utils/validators";
  import RenderToggleButton from "./button/RenderToggleButton.svelte";
  import {  getContext } from "svelte";
  const { onFormChange } = getContext("form");
  const selectAllItem = { value: "all", label: "Select All" };
  const tvData = {
    genres: [
      { label: "Action", value: "Action" },
      { label: "Adventure", value: "Adventure" },
      { label: "Comedy", value: "Comedy" },
      { label: "Crime / Gangster", value: "Crime / Gangster" },
      { label: "Drama", value: "Drama" },
      { label: "Fantasy", value: "Fantasy" },
      { label: "Horror", value: "Horror" },
      { label: "Science Fiction", value: "Science Fiction" },
    ],
    ratings: [
      { label: "TV-Y", value: "TV-Y" },
      { label: "TV-Y7", value: "TV-Y7" },
      { label: "TV-Y7 FV", value: "Y7 FV" },
      { label: "TV-G", value: "TV-G" },
      { label: "TV-PG", value: "TV-PG" },
      { label: "TV-14", value: "TV-14" },
      { label: "TV-MA", value: "TV-MA" },
    ],
  };
  // let countryRegions = [];
  // $: isUS = false;
  let channels = [];
  // let addressTypes = [
  //   { label: "ZIP", value: "ZIP", group: "US" },
  //   { label: "DMA", value: "DMA", group: "US" },
  //   { label: "State", value: "State", group: "US" },
  //   { label: "Region", value: "Regions", group: "ALL" },
  // ];
  export let formDetection = true;
  export let publisherChannelsValue = [];
  //export let statesValue = [];
  export let rating = [];
  //export let dmasValue = [];
  export let genres = [];
  // export let address_type = null;
  export let countriesValue = [];
  export let includePublishersInInventory;
  // let all_publishers_selected = false;
  // export let regionsValue = [];
  // export let zipCodes = [];

  // function addressTypeHandler(e) {
  //   resetAddressValues();
  //   address_type = e.detail.value;
  // }
  // function resetAddressValues() {
  //   dmasValue = [];
  //   regionsValue = [];
  //   zipCodes = [];
  //   statesValue = [];
  // }
  // function selectedFileChanged(e) {
  //   if (e.currentTarget?.files?.length === 0) {
  //     console.log("No file selected.");
  //     return;
  //   }
  //   const reader = new FileReader();
  //   reader.onload = function fileReadCompleted() {
  //     zipCodes = reader.result.split(",");
  //   };
  //   reader.readAsText(this.files[0]);
  // }
  function sortPublisherChannels(list) {
    return list.sort((a, b) => {
      const label1 = a.publishers.label.toUpperCase();
      const label2 = b.publishers.label.toUpperCase();
      return label1 < label2 ? -1 : label1 > label2 ? 1 : 0;
    });
  }
  async function loadAllChannels() {
    const allChannels = await fetchChannelsForPublisher();
    const publishers = await getPublishers();
    let mappedPublishers = {};
    publishers.forEach(
      (p) =>
        (mappedPublishers[p.publisher_id] = {
          label: p.name,
          value: p.publisher_id,
        })
    );
    // if (all_publishers_selected) {
    //   publisherChannelsValue = sortPublisherChannels(allChannels.map((c) => {
    //     let pub = mappedPublishers[c.publisher_id]
    //     return {
    //       publishers: pub,
    //       channels: {value: c.id, label: c.name},
    //       max_utilization: 100,
    //     };
    //   }).filter(g=>g.publishers));
    // } else {
    //   publisherChannelsValue = [];
    // }
  }
  async function getPublisherLists(route, filter) {
    try {
      const res = await getList(route, null, null, "name", "ASC", filter);
      return res.data;
    } catch (error) {
      console.log(error);
    }
  }
  async function fetchChannelsForPublisher(publisher_id) {
    const filter = publisher_id ? { publisher_id } : {};
    return await getPublisherLists("publisher/channels", filter);
  }
  async function getPublishers() {
    return await getPublisherLists("publisher", {});
  }
  async function loadChannels(e, input = undefined) {
    if (!e?.value) return;
    if (input) input["channels"] = null;
    channels = [];
    const channelsRes = await fetchChannelsForPublisher(e.value);
    if (channelsRes.length) {
      channels = [selectAllItem];
      channelsRes?.forEach((c) =>
        channels.push({ value: c.id, label: c.name, group: e.detail?.label })
      );
    } else {
      channels = [selectAllItem];
    }
    eligibleFields = eligibleFields;
  }
  $: eligibleFields = [
    {
      type: "combo",
      entity: "publishers",
      name: "publishers",
      label: "Publisher",
      preventDup: true,
      validations: [Validators.required("Publisher is required")],
      placeholder: "Select Publisher",
      isClearable: false,
      onValueChange: loadChannels,
      readonlyValue: true,
      placeholder: "Select Publisher",
    },
    {
      type: "combo",
      name: "channels",
      items: channels,
      preventDup: true,
      readonlyValue: true,
      isSelectAll: true,
      isClearable: false,
      validations: [Validators.required("Channels are required")],
      label: "Channel",
      placeholder: "Select Channels",
    },
    {
      type: "number",
      min: 0.1,
      step: 0.1,
      max: 100,
      defaultValue: 100,
      prefix: "%",
      isClearable: false,
      validations: [Validators.required("Max utilization is required")],
      readonlyValue: true,
      placeholder: "Set Max Utilization",
      name: "max_utilization",
      label: "Max Utilization",
    },
  ];
  function onAddRow(dataObj) {
    const newPublisherChannel = { ...dataObj };
    // select all is selected remove all other channels of that publisher form list
    if ((newPublisherChannel.channels.value = "all")) {
      publisherChannelsValue = publisherChannelsValue.filter(
        (pc) => pc.publishers.value != newPublisherChannel.publishers.value
      );
    }
    publisherChannelsValue.push(newPublisherChannel);
    return publisherChannelsValue;
  }
  function onDeleteRow(i) {
    // all_publishers_selected = false;
    const [deletedPublisherChannel] = publisherChannelsValue.splice(i, 1);
    //console.log(deletedPublisherChannel, "deleted");
    return publisherChannelsValue;
  }
  function setGenre(e) {
    genres = e.detail;
    //console.log({ genres, e: e.detail });
    genres = genres; // ridicules
  }

  function ToggleInclude(){
    includePublishersInInventory = !includePublishersInInventory;
    const details = {
      name: "includePublishersInInventory", detail: includePublishersInInventory
    }
    if (formDetection) onFormChange(details);
  }
  // function filterRegions(countriesArray, regionsArray = regions) {
  //   if (countriesArray[0] == "Select All") return regionsArray;
  //   return regionsArray.filter((r) => countriesArray.includes(r.country));
  // }
  // function setCountriesHandler(e) {
  //   if(e.detail == null && countriesValue.length != 1 )  return;
  //   countriesValue = e.detail || []
  //   const countriesValues = countriesValue.map((c) => c.value);
  //   const countriesLabels = countriesValue.map((c) => c.label);
  //   countryRegions = filterRegions(countriesLabels);
  //   isUS = countriesValues.includes("US") || countriesValues.includes("");
  //   if (!isUS) {
  //     statesValue = [];
  //     dmasValue = zipCodes = [];
  //   }
  //   addressTypes = addressTypes.map((item) => {
  //     if (!isUS && item.group == "US") {
  //       item.selectable = false;
  //     }
  //     else{
  //       item.selectable = true;
  //     }
  //     return item;
  //   });
  //   regionsValue = filterRegions(
  //     countriesLabels,
  //     regionsValue
  //   );
  // }
  // const countryGroupBy = (item) => item.country;
</script>

  <div class="flex flex-row mt-8">
    <div class="flex-initial text-md text-black font-bold">
      Eligible Inventory
    </div>
    <!-- <div class="flex-initial">
    <label for={name} class="grow strong w-full text-sm font-bold"
      >Categories {is_categories_whitelist
        ? "Whitelist"
        : "Blocklist"}
    </label>
  </div>
  <div class="flex-auto" /> -->
    <div class="flex-auto" />
    <div class="pt-0.5">
      <RenderToggleButton
        active={includePublishersInInventory}
        size={24}
        click={() => ToggleInclude()}
        colors={{ on: "#009834", off: "#333333" }}
      />
    </div>
    <div class="pl-1 text-sm">
      {includePublishersInInventory ? "Include" : "Exclude"} Inventory
    </div>
  </div>
<div class="border border-gray-400 rounded-md mb-2 p-2">
  <div class="text-sm mb-6 text-gray">
    Fields below will be combined as (Publisher AND Channel AND Max Utilization)
    OR Genre OR Rating
  </div>
  <!-- <SingleCheckbox
  name=""
  on:onChange={loadAllChannels}
  label="Select All Publishers and Channels"
  bind:value={all_publishers_selected}
/> -->
  <AddList
    name="publisher_channels"
    fields={eligibleFields}
    data={publisherChannelsValue}
    {onAddRow}
    {onDeleteRow}
  />
  <div class="flex flex-row gap-2 mt-10 w-1/2">
    <InputWrapper label="Genre">
      <AutoCompleteCombo
        placeholder="Select Genre"
        name="genre"
        isMulti
        isSelectAll
        on:change={setGenre}
        bind:value={genres}
        items={tvData.genres}
      />
    </InputWrapper>
  </div>
  <div class="flex flex-row gap-2 mt-10 w-1/2">
    <InputWrapper label="Rating">
      <AutoCompleteCombo
        name="rating"
        isSelectAll
        placeholder="Select Ratings"
        bind:value={rating}
        isMulti
        items={tvData.ratings}
      />
    </InputWrapper>
  </div>
</div>
<div class="text-md mb-5 mt-14 text-black font-bold">Eligible Geo</div>
<div class="flex flex-row gap-2 w-1/2">
  <InputWrapper label="Country">
    <AutoCompleteCombo
      name="country"
      isSelectAll
      placeholder="Select Country"
      bind:value={countriesValue}
      isMulti
      items={countries}
    />
  </InputWrapper>
</div>
<!-- <div class="flex flex-row gap-2 mt-10">
  <InputWrapper label="Address Type" class="h-12 w-1/2">
    <AutoCompleteCombo
      name="address_type"
      placeholder="Select address type"
      value={address_type}
      on:change={addressTypeHandler}
      items={addressTypes}
    />
  </InputWrapper>
  {#if address_type == "State"}
    <InputWrapper label="State">
      <AutoCompleteCombo
        name="State"
        isSelectAll
        disabled={!isUS}
        placeholder="Select States"
        bind:value={statesValue}
        isMulti
        items={states}
      />
    </InputWrapper>
  {:else if address_type == "DMA"}
    <InputWrapper label="DMA">
      <AutoCompleteCombo
        name="DMA"
        isSelectAll
        disabled={!isUS}
        placeholder="Select DMA"
        bind:value={dmasValue}
        isMulti
        items={dma}
      />
    </InputWrapper>
  {:else if address_type == "Regions"}
    <InputWrapper label="Regions">
      <AutoCompleteCombo
        name="region"
        isSelectAll
        placeholder="Select Regions"
        groupBy={countryGroupBy}
        value={regionsValue}
        on:change={(e)=>{regionsValue = e.detail}}
        isMulti
        items={countryRegions}
      />
    </InputWrapper>
  {:else if address_type == "ZIP"}
    <InputWrapper label="Zip Code" subLabel="Upload CSV file with comma separated values OR insert manually">
      <div class="flex">
        <div
          id="zip"
          class="bg-custom-light-orange border-2 border-custom-orange border-dashed flex justify-center py-3 rounded-md w-full"
        >

          <div class="space-y-1 text-center">
            <div class="flex text-sm text-gray-600">
              <label
                for="file-upload"
                class="relative cursor-pointer rounded-md font-medium text-yellow-600 hover:text-yellow-500 outline-none"
              >
                <span>Upload a File</span>
                <input
                  id="file-upload"
                  name="zip_file"
                  type="file"
                  disabled={!isUS}
                  class="sr-only"
                  accept="csv"
                  on:change={selectedFileChanged}
                  multiple
                  draggable="true"
                />
              </label>
              <p class="pl-1">or drag and drop</p>
              <span class="ml-1.5">
                <CustomIcon width="17" height="17" name="image_upload" />
              </span>
            </div>
          </div>
        </div>
        <div class="w-full">
          <InputTags
            name="zip_codes"
            addKeys={[188, 9]}
            addOnPaste
            onlyUnique
            tags={zipCodes}
          />
        </div>
      </div>
    </InputWrapper>
  {/if}
</div> -->
